import React, { useState, useEffect } from "react";
import WelcomeSection from "./dashboard/WelcomeSection";
import TodayFocus from "./dashboard/TodayFocus";
import ReachRow from "./dashboard/ReachRow";
import ActivityStrip from "./dashboard/ActivityStrip";
import FromYourNetwork from "./dashboard/FromYourNetwork";
import ContinueLearning from "./dashboard/ContinueLearning";
import QuickActions from "./dashboard/QuickActions";
import RightSidebar from "./dashboard/RightSidebar";
import { useAuthContext } from "../hooks/useAuthContext";

const DashboardContent = ({ onUploadClick }) => {
  const { token } = useAuthContext();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const res = await fetch("/api/dashboard/summary", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.ok) {
        const result = await res.json();
        setData(result);
      } else {
        setError("Failed to fetch dashboard data");
      }
    } catch (err) {
      console.error(err);
      setError("Network error fetching dashboard");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchDashboardData();
    }
  }, [token]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary"></div>
        <span className="text-sm text-muted-foreground animate-pulse">Loading dashboard...</span>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="max-w-[1440px] mx-auto px-6 py-12 text-center">
        <div className="p-8 rounded-2xl bg-card border border-border shadow-xl max-w-md mx-auto">
          <h3 className="text-lg font-bold text-foreground mb-2">Error Loading Dashboard</h3>
          <p className="text-sm text-muted-foreground mb-6">{error || "Something went wrong"}</p>
          <button
            onClick={fetchDashboardData}
            className="px-5 py-2.5 rounded-xl bg-primary text-primary-foreground font-bold hover:bg-primary/90 transition-all border-none cursor-pointer"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-[1440px] mx-auto px-6 py-6 animate-fade-in">
      <div className="flex gap-6 flex-col xl:flex-row">
        {/* Main Content Area */}
        <div className="flex-1 min-w-0 space-y-6">
          {/* Ordered by what someone needs on arrival: where am I today, how
              is my work doing, what was I in the middle of, then actions. */}
          <WelcomeSection userProfile={data.user} />

          <TodayFocus today={data.today} />

          <ReachRow reach={data.reach} />

          <ActivityStrip analytics={data.learningAnalytics} />

          <ContinueLearning item={data.continueLearning} />

          <FromYourNetwork uploads={data.networkUploads} />

          <QuickActions onUploadClick={onUploadClick} />

          {/* <Announcements /> */}
        </div>

        {/* Right Sidebar - Sticky on desktop */}
        <div className="w-full xl:w-72 flex-shrink-0">
          <div className="xl:sticky xl:top-24">
              <RightSidebar 
                // nextEvent={data.nextEvent}
                // yourRank={data.yourRank}
                recommended={data.recommended}
              />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardContent;
